const Sdata = [
    {
      id: 1,
      title: "  THE STANDARD",
      desc: "The Standard, previously called East African Standard, English-language daily newspaper published in Nairobi, Kenya. It was established in Mombasa in 1902 as a weekly, the African Standard, by A.M. Jeevanjee, an Indian merchant",
      cover:"https://cdn.standardmedia.co.ke/images/friday/ujgfvqz9lkrqzg859a03ea4cfd0b.jpg"
     
    },
    {
      id: 2,
      title: "DAILY NATION",
      desc: "The newspaper is published by Nation Media Group from its headquarters at Nation Centre on Kimathi Street in Nairobi. It also maintains a website, which hosts online editions of the daily and Sunday titles. Access is partially free and the site's daily hit rate is more than three million.",
      cover:"https://lh3.googleusercontent.com/l6UQsq2H4nG2OK3MGIrCuTZIYcZAGJpKUp9Tk568dnVCZHkjoe3VnWmFii9VGnIjb3Y"
    },
    {
      id: 3,
      title: "TAIFA LEO",
      desc: "The TAIFA LEO was started in the year 1958 as a Swahili weekly called Taifa by the Englishman Charles Hayes. It was bought in 1959 by the Aga Khan, and became a daily newspaper, Taifa Leo (Swahili for 'Nation Today'), in January 1960",
      cover:"https://www.nationmedia.com/wp-content/uploads/2017/03/brand-taifa-leo.png"
    },
    {
      id: 4,
      title: "THE NAIROBIAN",
      desc: "The newspaper was established as The Nairobian Newspaper in 1902 as a weekly by Alibhai Mulla Jeevanjee, an immigrant businessman from British India",
      cover:"https://pbs.twimg.com/profile_images/572456599327748096/375P1pGm_400x400.jpeg"
    },
]
export default Sdata